import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { useLoginVerify } from '../hooks/useLoginVerify';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const AuthWrapper = ({
  children
}) => {
  const {
    loading,
    isLoggedIn
  } = useLoginVerify();
  if (loading) {
    return /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      blockSize: "100vh",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {})
    });
  }
  if (isLoggedIn) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "NOT_AUTHENTICATED"
  });
};